export const captcha_key = "6Ld6xdckAAAAAK5qhScMIOFIY15C-Se1wwDuY-DX"
